import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  popover: {},
  modalBody: {},
}));

export default useStyles;
